import React from 'react';
import BaseModal from '../BaseModal';

// "Which template?" — asked when a submission's form has more than one to
// print it with. Each template is a button in the body; Cancel is the footer.
const TemplatePickerModal = ({ open, templates, onChoose, onCancel }) => (
  <BaseModal
    open={open}
    titleId="template-picker-title"
    title="Download PDF"
    message="Choose the template to lay this submission out with."
    onSubmit={(e) => e.preventDefault()}
    onCancel={onCancel}
    showConfirm={false}
  >
    <div className="max-h-[55vh] overflow-y-auto space-y-2 pr-1">
      {templates.map((template) => (
        <button
          key={template.id}
          type="button"
          onClick={() => onChoose(template)}
          className="w-full text-left bg-gray-700/40 border border-purple-500/40 hover:bg-purple-500/20 hover:border-purple-400 rounded-lg px-4 py-3 font-semibold text-white transition-colors duration-200"
        >
          {template.name}
        </button>
      ))}
    </div>
  </BaseModal>
);

export default TemplatePickerModal;
